import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge conditional Tailwind class names. Mirrors shadcn's helper so
 * copy-pasted primitives resolve unmodified. Use this anywhere you'd
 * otherwise write `clsx(...)` directly — it deduplicates conflicting
 * Tailwind classes (e.g. `cn("p-2", isWide && "p-4")` → `p-4`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
